export default __webpack_public_path__ + "macbook@2x.0a4ff68a.png";